module.exports = __webpack_public_path__ + "static/media/017.52cd93dd.jpg";